import { render, staticRenderFns } from "./PersonalOrder.vue?vue&type=template&id=01007edb&scoped=true&"
import script from "./PersonalOrder.vue?vue&type=script&lang=js&"
export * from "./PersonalOrder.vue?vue&type=script&lang=js&"
import style0 from "./PersonalOrder.vue?vue&type=style&index=0&id=01007edb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01007edb",
  null
  
)

export default component.exports